import { widths } from '~/eds/src/tokens/sizes/widths';

export const TICKET_DETAILS_PANEL_WIDTH = `${widths['panel.width.m']}px`;
export const TICKET_DETAILS_MAIN_CONTENT_MIN_WIDTH = '600px';
